export function ProjectContextChip({ title, onClear }: { title: string; onClear: () => void }) {
  return <div className="quickway-context-chip">
    <i className="ri-at-line" aria-hidden="true" />
    <span>{title}</span>
    <button
      type="button"
      aria-label={`移除项目上下文：${title}`}
      title="移除项目上下文"
      onClick={onClear}
      style={{ border: 0, background: 'transparent', color: 'inherit', display: 'grid', placeItems: 'center', width: 16, height: 16, padding: 0, flex: '0 0 auto' }}
    >
      <i className="ri-close-line" aria-hidden="true" />
    </button>
  </div>
}
